var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearJar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 102,
    viewBox: "0 0 42 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.875 10.5H13.125V11.8125H12.4688C12.1063 11.8125 11.8125 12.1063 11.8125 12.4688C11.8125 12.8312 12.1063 13.125 12.4688 13.125H13.125V14.4375H12.4688C12.1063 14.4375 11.8125 14.7313 11.8125 15.0938C11.8125 15.4562 12.1063 15.75 12.4688 15.75H13.125V17.0625H12.4688C12.1063 17.0625 11.8125 17.3563 11.8125 17.7188C11.8125 18.0812 12.1063 18.375 12.4688 18.375H13.125V19.6875H11.8125C11.0876 19.6875 10.5 20.2751 10.5 21C10.5 21.7249 11.0876 22.3125 11.8125 22.3125H13.125V24.9375C13.125 24.9375 0 35.9148 0 46.892C0 47.0127 0.00507302 47.132 0.0151076 47.25H0V94.0625C0 97.9285 3.13401 101.062 7 101.062H35C38.866 101.062 42 97.9285 42 94.0625V47.25H41.9849C41.9949 47.132 42 47.0127 42 46.892C42 35.9204 28.8884 24.9487 28.875 24.9375L28.875 24.9375V22.3125H30.1875C30.9124 22.3125 31.5 21.7249 31.5 21C31.5 20.2751 30.9124 19.6875 30.1875 19.6875H28.875V18.375H29.5312C29.8937 18.375 30.1875 18.0812 30.1875 17.7188C30.1875 17.3563 29.8937 17.0625 29.5312 17.0625H28.875V15.75H29.5312C29.8937 15.75 30.1875 15.4562 30.1875 15.0938C30.1875 14.7313 29.8937 14.4375 29.5312 14.4375H28.875V13.125H29.5312C29.8937 13.125 30.1875 12.8312 30.1875 12.4688C30.1875 12.1063 29.8937 11.8125 29.5312 11.8125H28.875V10.5Z",
    fill: "#CCD8E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 46.2727C2 44.2955 3.35714 41 3.35714 41H38.6429C38.6429 41 40 43.6364 40 46.2727C40 48.2921 40 78.1536 40 92.0199C40 95.8859 36.866 99 33 99H9C5.13401 99 2 95.8858 2 92.0198C2 78.0364 2 47.7903 2 46.2727Z",
    fill: "#33BEF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3239 26.25C9.75947 30.4386 2 40.2709 2 46.0909C2 46.0909 2 46.0909 2 46.0909V92C2 96.188 5.5 99 9 99C8.84379 98.9981 10.6782 98.9816 11.5852 98.9816V46.0909H11.5852C11.5852 46.0909 11.5852 46.0909 11.5852 46.0909C11.357 40.3591 17.0625 26.25 17.0625 26.25H14.3239Z",
    fill: "#E5ECF0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 53.8125C0 53.8125 0 55.125 21 55.125C42 55.125 42 53.8125 42 53.8125V80.0625C42 80.0625 42 81.375 21 81.375C0 81.375 0 80.0625 0 80.0625V53.8125Z",
    fill: "#F7F7F7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    width: 24,
    height: 20,
    rx: 2,
    fill: "#66A1DB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    width: 8,
    height: 20,
    rx: 2,
    fill: "#99C1E7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 3,
    width: 2,
    height: 14,
    rx: 1,
    fill: "#3382CF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 3,
    width: 2,
    height: 14,
    rx: 1,
    fill: "#3382CF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 3,
    width: 2,
    height: 14,
    rx: 1,
    fill: "#3382CF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 3,
    width: 2,
    height: 14,
    rx: 1,
    fill: "#3382CF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 3,
    width: 2,
    height: 14,
    rx: 1,
    fill: "#3382CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearJar);
export default __webpack_public_path__ + "static/media/clear_jar.4359fde88f2c74d3205cc4efca1b1225.svg";
export { ForwardRef as ReactComponent };